<template id="simple-report-page">
  <section>
    <div class="row">
      <div class="col-md-10 col-lg-12 text-center mt-3 mb-5 p-4">
        <div class="card">
          <div class="card-header text-left">
            <i class="fa fa-file"></i> {{ repTitle }}
            <div class="float-right">
                   <span v-for="(ai,index) in currentRepActionIconsData" :key="index">
          <download-csv v-if="ai.actionIconsName=== 'download'" class="btn btn-default" :data="cleanedDownload"
                        :name="momentAll" v-on:click="handleActionIconFunctionCall(ai.functionName,index)">
            <i v-bind:id="ai.iconId" v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
               :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
               style="font-size:15px; float: right; margin-top: -3px; ">
            </i>
          </download-csv>

          <span v-on:click="handleActionIconFunctionCall(ai.functionName,index)">
              <i v-if="ai.actionIconsName!== 'download'" v-bind:id="ai.iconId"
                 v-bind:class="[iconOnChangeFlag[index]===true ? ai.iconClass:ai.iconOnchangeClass]"
                 :title="[iconOnChangeFlag[index] ? ai.iconTooltip:ai.iconOnchangeTooltip]"
                 style="font-size:15px; padding-left:10px;">
              </i>
          </span>
        </span>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <div>
                <table width="100%">
                  <tr>
                    <th class="thead-dark" align="center" v-for="key in dimSelectDpValues" v-bind:key="key"> {{ key }}
                    </th>
                    <b>Generic Search</b>
                  </tr>
                  <tr>
                    <td v-for="(key,index) in dimSelectDpValues" v-bind:key="key">
                      <v-select multiple style="width: 100px;" v-bind:key="key"
                                v-model="selectVal[rowsDataDimKeys[index]]" :options="options[rowsDataDimKeys[index]]">

                        <!--<option value="">All</option>
                        <option style="width: 30px;" :value="option" v-for="option in options[rowsDataDimKeys[index]]" :key="option">{{ option }}</option>-->
                      </v-select>
                    </td>
                    <input type="text" v-model="filterValue" placeholder="Search">
                  </tr>
                </table>
              </div>
              <br>
              <!--              <div class="grid-container">-->
              <!--                <table class="table table-hover table-bordered">-->
              <!--                  <thead class="thead-dark" align="center">-->
              <!--                  <tr>-->
              <!--                    <th v-for="(col,index) in columns" v-bind:key="col">-->
              <!--                      {{col}}-->
              <!--                      <a href="#" @click="sortBy(Rcolumns[index])">-->
              <!--                        <i class="fa" v-bind:class="Rcolumns[index]===sortKey ? (sortOrder === 'asc' ?  'fa-sort-amount-down-alt' : 'fa-sort-amount-up-alt') : 'fa-sort' " v-bind:style="[Rcolumns[index]===sortKey ? {'color':'Gold'} : {'color':'White'}]" ></i>-->
              <!--                      </a>-->
              <!--                    </th>-->
              <!--                  </tr>-->
              <!--                  </thead>-->
              <!--                  <tbody >-->
              <!--                  <tr v-for="(rowd,index) in filteredItems  " v-bind:key="index">-->
              <!--                    <td :class="{'text-right' : col.startsWith('rm'), 'text-danger':rowd['rm7']>40}" v-for="col in Rcolumns" v-bind:key="col">{{rowd[col]}}</td>-->
              <!--                  </tr>-->
              <!--                  </tbody>-->
              <!--                </table>-->
              <!--              </div>-->
              <div class="overflow-auto" >
                <div style="text-align:right; display:inline-block;">
                  <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      align="center"
                      aria-controls="my-table"
                  ></b-pagination>
                </div>
                <div style="text-align: left;display:inline-block; padding: 10px; ">
                  <p class="sm-2 text-primary">No.of Rows: {{ rows }}</p>
                </div>

                <!--                <span style="padding-top:1em;">No.of Rows: {{rows}}</span>-->
                <!--        <p class="mt-3">Current Page: {{ currentPage }}</p>-->
                <div class="scrollmenuRepo">
                  <b-table
                      id="my-table"
                      :items="filteredItems"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :fields="merged_column_label"
                      :sort-by.sync="sortBy1"
                      :sort-desc.sync="sortDesc"
                      sort-icon-right
                      bordered
                      small>

                    <!--                  <b-table-column numeric v-for="header in numeric_headers" v-slot=></b-table-column>-->
                    <!--                  <template #cell()="filteredItems">-->
                    <!--        <span :class="{ right: typeof filteredItems.value == 'number', left: typeof filteredItems.value != 'number' }">-->
                    <!--          {{ filteredItems.value }} </span>-->
                    <!--                  </template>-->
                    <template v-for="header in numeric_headers"  v-slot:[toCellName(header)]="filteredItems" >
                      <div class="text-right" v-bind:key="header">{{ filteredItems.value }}</div>
                    </template>
                    <!--                  <template v-slot:cell(rm2)="filteredItems">-->
                    <!--                    <div class="text-right">{{ filteredItems.value }}</div>-->
                    <!--                  </template>-->
                    <!--                  <template v-slot:cell(rm3)="filteredItems">-->
                    <!--                    <div class="text-right">{{ filteredItems.value }}</div>-->
                    <!--                  </template>-->
                  </b-table>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import _ from 'lodash'
import moment from "moment";

//var $ = require("jquery");

export default {
  name: 'simple-report-page',

  data: function () {
    return {
      output: [],
      repTitle: '',
      columns: [],
      keys: [],
      rowsdata: [],
      sortKey: [],
      sortOrder: ['asc'],
      dimSelectDpValues: [],
      rowsDataDimKeys: [],
      filterValue: '',
      currentRepActionIconsData: {},
      cleanedDownload:[],
      iconOnChangeFlag: [],
      // This is much simpler if the select is it's own component.
      selectVal: {
        isActive: undefined,
        age: undefined,
        first_name: undefined,
        last_name: undefined
      },
      perPage: 20,
      currentPage: 1,
      merged_column_label: [],
      sortBy1: '',
      sortDesc: false,
      numeric_headers: ['rm1','rm2','rm3','rm4','rm5','rm6','rm7','rm8','rm9','rm10'],
    }
  },
  created: function () {
    //this.loadCustomerSales()
    //   this.loadReportConfig()
    this.listenToRouter()
  },
  mounted: function () {
    // this.init();
    this.loadReportConfig()

  },
  computed: {
    rows() {
      return this.filteredItems.length
    },
    "Rcolumns": function columns() {
      if (this.rowsdata.length == 0) {
        return [];
      }
      return Object.keys(this.rowsdata[0])
    },
    "orderedData": function () {
      let result = this.apiData;
      if (this.filterValue) {
        result = result.filter(item => item.rd2.includes(this.filterValue));
      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    filteredItems() {
      let result = this.rowsdata.filter(item => {
        let keep = true;
        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.rowsDataDimKeys.forEach(key => {
          if (this.selectVal[key]) {
            // console.log("filter ", this.selectVal,this.selectVal[key].length==0)
            keep =
                keep &&
                (this.selectVal[key].length == 0 ||
                    //item[key] === this.selectVal[key]); // true && (false ||
                    this.selectVal[key].includes(item[key])); // true && (false ||
          }
        });
        return keep;
      });
      if (this.filterValue) {
        /* Filters the report Data based on the entered value in the generic search box
           loop over the keys of the inner object and use Array.some()
           It will work for any number of keys of any name so no need to get depend on the keys
           to get the match of the searched text use includes()
           to make the search non case sensitive use toLowerCase()
           to avoid NULL values in filtering excluded null values by taking !=Null and with && operator
           Numeric values gave obj[key].includes is not function error so converted them to string using toString()
        */
        result = result.filter(obj =>
            Object.keys(obj)
                .some(key => (obj[key] != null) && obj[key].toString().toLowerCase().includes(this.filterValue.toLowerCase()))
        );
      }
      return _.orderBy(result, this.sortKey, this.sortOrder)
    },
    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      this.rowsDataDimKeys.forEach(key => {
        const vals = this.rowsdata.map(item => item[key]);
        console.log("Options Data Vals", vals);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals)).sort();
        console.log("Distinct Options Data ", options[key]);
      });
      return options;
    },
  },
  methods: {
    toCellName (slot) {
      console.log("slot:",slot)
      return `cell(${slot})`
    },
    sortBy: function (key) {
      console.log("The sort Key is ", key)
      if (key == this.sortKey) {
        this.sortOrder = (this.sortOrder == 'asc') ? 'desc' : 'asc';
        this.sortKey = key;
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
    },

    //Get Request
    /*loadCustomerSales: function () {
      axios.get('/api/v_retailer_monthly')
        .then(res => {
          this.rowsdata = res.data
          console.log('Test', this.rowsdata)
        }, err => {
          console.log('Error fetching data', err)
        })
    },*/
    listenToRouter: function () {
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        //console.log(`router moved to ${from.path} from ${to.path}, page viz = ${$this.rows.length}`)
        $this.rowsdata = []
        $this.headerColumns = []
        $this.merged_column_label = []
        setTimeout(() => {
          $this.loadReportConfig()
        }, 300)

      })
    },
    handleActionIconFunctionCall(fnName, index,x) {
      let val = !this.iconOnChangeFlag[index]
      this.$set(this.iconOnChangeFlag, index, val) //Array mutation happens only by set function or other mutation methods like slice,push,pop etc
      console.log("Handle function called with func name", fnName, this.iconOnChangeFlag,x)
      this[fnName](x)
    },

    commentBox: function (id) {
      let what = this.reportDataConfig.columns[0]
      console.log(
          `ENTERED into the commentBox function(${id},${what.menuName}, ${what.reportName})`
      );
      this.cmt = "";
      this.pg = what.menuName;
      this.section = id;
      this.annotationHeader = "User Annotations";
      this.annotationTitle =
          this.annotationHeader + "->" + this.pg + "->" + this.section;
      this.$refs["comment-box"].show();
    },
    postAnnotation: function () {
      const url = "/api/businessActions";
      const data = {
        userId: 1,
        userName: "Admin",
        menuName: this.pg,
        screenletName: this.pg,
        vizletName: this.pg,
        recordIdentification: this.section,
        annotation: this.cmnt,
      };
      axios.post(url, data).then(
          () => {
            this.$store.dispatch("loadAnnotations");
          },
          (e) => {
            this.$commonFn.auditLog(menu, subMenu, "", "POST", e);
            console.error("error in updating annotations", e);
          }
      );
      let menu = this.pg;
      let subMenu = this.section;
      console.log("the menus and submenus for Audit log is", menu, subMenu);

      this.$commonFn.auditLog(menu, subMenu, "", "POST", "Success");
    },

    loadReportConfig: function () {
      console.info('loading summary')
      let menuParam = this.$route.params.submenuId
      //  let submenuParam = this.$route.params.submenuId

      //Get Request
      axios.get('/api/reportConfigColumn/' + menuParam)
          //           axios.get('/api/reportConfigColumn/'+ menuParam +'/'+submenuParam)
          .then(res => {
            this.apiData = res.data
            this.rowsdata = this.apiData.rowsData
            this.repTitle = this.apiData.columns[0].reportName
            //this.columns = this.apiData.columns
            this.columns = this.apiData.columns.map(function (el) {
              return el.headerColumnDisplay;
            })
            this.icons = this.apiData.icons
            this.cleanedDownload = this.apiData.downloadRowsData
            this.momentAll = `${moment().format('YYYY-MM-DD hh:mm')}_${this.repTitle}.csv`
            console.log('ReportConfigRes', this.apiData)
            var rowsDataKeys = Object.keys(this.rowsdata[0])
            this.rowsDataDimKeys = rowsDataKeys.filter(dim => dim.includes('d'))
            this.dimSelectDpValues = this.columns.slice(0, this.rowsDataDimKeys.length)
            console.log('Dimension variables Keys', this.rowsDataDimKeys)
            console.log('Data for Report', this.rowsdata)
            console.log('Dimension variables Keys', this.dimSelectDpValues)
            //console.log('Report Title',this.apiData.columns[0].repName)
            //console.log('Report headers',this.nameArray)

            //Rep level action icons
            let actionIconsData = this.$store.state.actionIcons
            let repIcons = this.icons.filter(indi => indi.drilldownLevel == 'level1') // get only level1 for report level icons
            console.log('Rep Icons:', repIcons)
            var repActionIconsSyspkArray = repIcons[0].repActionIconsSyspkArray ? repIcons[0].repActionIconsSyspkArray : []
            console.log('Rep Action icons', repActionIconsSyspkArray, repIcons[0].repActionIconsSyspkArray)
            this.currentRepActionIconsData = actionIconsData.filter(r => repActionIconsSyspkArray.includes(r.syspk))
            console.log('Rep Action icons:',repActionIconsSyspkArray)

            //b-table header
            for (let i = 0; i < this.Rcolumns.length; i++) {
              this.merged_column_label.push({
                key: this.Rcolumns[i],
                label: this.columns[i],
                sortable: true,
                tdClass: 'text-left',
                thClass: 'text-center bg-info text-light',
              })
            }
            console.log("columns:", this.merged_column_label);



            /*   $('td').filter(function () {
                 return /^[.,\d]+$/.test($(this).text());
               })
                   .css({
                     'text-align': 'right'
                   });

               $('td').filter(function () {
                 return /^[a-zA-Z\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/.test($(this).text());
               })
                   .css({
                     'text-align': 'left'
                   });
   */

          }, err => {
            console.log('Error Fetching data', err)
          })


      /*               //Get Request
                      axios.get('/api/reportConfigColumn/'+ menuParam +'/G01')
                      .then(res => {
                      this.drilldowndata = res.data
                      var columns = this.drilldowndata.columns
                      //var rowsdata = this.drilldowndata.rowsdata
                      console.log("API Response",this.drilldowndata)
                      var drilldownlevels = [...new Set(columns.map(dl => dl.drilldownLevel))] //... is the spread operator, which will expand the set values into an array.
                      var levelColumns = []
                      var headerColumns = []
                      for (var i=1; i<=drilldownlevels.length; i++)
                      {
                          var value ='level'+i
                          levelColumns[i] = columns.filter( ind => ind.drilldownLevel ==value)
                          headerColumns[i] = levelColumns[i].map(function (el) { return el.headerColumnDisplay;})
                      }
                      //this.headerColumnsDisplay = this.apiData.columns.map(function (el) { return el.headerColumnDisplay; })
                      console.log("Drilldown data level1",headerColumns[1])
                      console.log("Drilldown data level2",headerColumns[2])
                      console.log("Drilldown data level3",headerColumns[3])

                      }, err => {
                      console.log('Error Fetching data', err)
                      })

                     //Post Request
                     const params = new URLSearchParams();
                     params.append('param1', 'value1');
                     params.append('param2', 'value2');
                     axios.post('/api/testparams', params)
                     //axios.post('/api/reportConfigColumn/'+ menuParam +'/G01')
                     .then(res => {
                      this.string = res.data
                     //var columns = this.drilldowndata.columns
                     //var rowsdata = this.drilldowndata.rowsdata
                     console.log("Post API Called",this.string)
                     }, err => {
                         console.log('Error Fetching data', err)
                         })
                 }*/

    }
  }
}
</script>
<style scope>
th {
  font-size: 12px;
}

.grid-container {
  overflow-y: auto;
  height: 500px;
}

a {
  text-decoration: none;
  display: inline-block;
  padding: 8px 16px;
}

a:hover {
  background-color: #ddd;
  color: black;
}

.previous {
  background-color: #f1f1f1;
  color: black;
}

.next {
  background-color: #f1f1f1;
  color: black;
}

.round {
  border-radius: 50%;
}

td {
  text-align: center;
}

td:first-of-type {
  text-align: left;
}
.right {
  display: flex;
  justify-content: right;
}
.left {
  display: flex;
  justify-content: left;
}
.scrollmenuRepo {
  overflow: auto;
  white-space: nowrap;
  height: 500px;
}
</style>